import { clientApi } from 'api';

export const deleteHomeProduct = (isServer = false) => async (id: string) => {
  const response = await clientApi.delete(`/home-products/${id}`);

  return response;
};
